import { Link } from "react-router-dom";
import { SITE, FOOTER } from "@/content/copy";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <p className="font-extrabold text-white text-lg tracking-tight">Clarus Partners</p>
            <p className="mt-3 text-sm leading-relaxed max-w-sm">{FOOTER.tagline}</p>
            <p className="mt-4 text-sm">
              <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="underline decoration-terracotta underline-offset-4 hover:text-white transition-colors">
                {SITE.email}
              </a>
            </p>
            <p className="mt-2 text-xs text-white/50">{FOOTER.abn}</p>
          </div>
          <div>
            <p className="text-sm font-bold uppercase tracking-widest text-white/50">Explore</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li><a href="/#services" data-testid="footer-services-link" className="hover:text-white transition-colors">Services</a></li>
              <li><a href="/#how-it-works" data-testid="footer-how-it-works-link" className="hover:text-white transition-colors">How it works</a></li>
              <li><a href="/#faq" data-testid="footer-faq-link" className="hover:text-white transition-colors">FAQ</a></li>
              <li><Link to="/xero-health-check" data-testid="footer-health-check-link" className="hover:text-white transition-colors">Free Xero Health Check</Link></li>
              <li><Link to="/pricing" data-testid="footer-pricing-link" className="hover:text-white transition-colors">Services & Pricing Guide</Link></li>
              <li><Link to="/articles" data-testid="footer-articles-link" className="hover:text-white transition-colors">Articles</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-sm font-bold uppercase tracking-widest text-white/50">Legal</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 text-xs text-white/40">
          © {new Date().getFullYear()} Clarus Partners. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
